/* eslint-disable react/forbid-prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { DATE_TIME_FORMAT } from 'src/constants/CommonConstants';
import { Form, Formik } from 'formik';
import FormikFile from 'src/components/formik/FormikFile';
import FormikInput from 'src/components/formik/FormikInput';
import FormikSelect from 'src/components/formik/FormikSelect';
import { isProduction } from 'src/config/index';
import { withFormikDevtools } from 'formik-devtools-extension';
import { useDispatch } from 'react-redux';
import LinkComponent from 'src/components/LinkComponent';
import classNames from 'classnames';
import { FileDefaultProps, FileYupSchema } from './FilePropTypes';
import { FILE_TYPES_LIST } from './FileConstants';
import SearchContainer from '../search-container/SearchContainer';
import { fileInsertAction, fileRemoveAction, fileSearchAction } from './actions/FileActions';
import { fileCreateAPI, fileDownloadAPI } from 'src/api/FileApi';
import { headerShowAction } from '../header-container/actions/HeaderActions';

const columns = {
    mime: {
        display: 'Mime',
    },
    fileType: {
        display: 'Type',
    },
    remark: {
        display: 'About File',
    },
    extension: {
        display: 'Extension',
    },
    deleted: {
        display: 'deleted',
        type: Boolean,
    },
    deletedTs: {
        display: 'deleted TS',
        type: Date,
        format: DATE_TIME_FORMAT.TIMEAGO,
    },
    deletedBy: {
        display: 'deleted By',
        path: 'deletedBy.personalInfo.firstName',
    },
    by: {
        display: 'By',
        path: 'by.personalInfo.firstName',
    },
    ts: {
        display: 'Ts',
        type: Date,
        format: DATE_TIME_FORMAT.TIMEAGO,
    },
};

const MAX_FILE_SIZE_BYTES = 7 * 1024 * 1024;

// const RenderDownload = ({ record }) => (
//     <LinkComponent
//         className={classNames({
//             'd-none': Boolean(record.deleted),
//         })}
//         onClick={() => {
//             window.open(record.url, '_blank');
//         }}
//     >
//         <i className="fas fa-download" />
//     </LinkComponent>
// );

// const RenderDownload = ({ record }) => (
//     <LinkComponent
//         className={classNames({
//             'd-none': Boolean(record?.deleted),
//         })}
//         onClick={() => {
//             if (record?.url) {
//                 window.open(record.url, '_blank');
//             }
//         }}
//     >
//         <i className="fas fa-download" />
//     </LinkComponent>
// );


// RenderDownload.propTypes = {
//     record: PropTypes.shape({
//         deleted: PropTypes.bool,
//     }).isRequired,
// };

const RenderDownload = ({ record }) => {
    const handleDownload = () => {
        if (record?._id && record?.remark) {
            fileDownloadAPI(record.url, record.remark || 'downloaded-file');
        } else {
            alert('File cannot be downloaded. Missing ID or file name.');
        }
    };

    return (
        <LinkComponent
            className={classNames({
                'd-none': Boolean(record?.deleted),
            })}
            onClick={handleDownload}
        >
            <i className="fas fa-download" />
        </LinkComponent>
    );
};

RenderDownload.propTypes = {
    record: PropTypes.shape({
        _id: PropTypes.string,
        remark: PropTypes.string,
        deleted: PropTypes.bool,
    }).isRequired,
};

const Render = (props) => {
    // DEV TOOL
    if (!isProduction()) {
        withFormikDevtools(props);
    }

    const {
        values,
        setFieldValue,
        canUpload,
    } = props;
// --------------for mutiple file/images/doc File--------------//
    // const handleFileChange = (e) => {
    //     const selectedFiles = e.target.files;
    //     setFieldValue('file', selectedFiles); // Update the file field value
    //     // setFieldValue('remark', ''); 
    //     if (selectedFiles.length > 0) {
    //         const fileNames = Array.from(selectedFiles).map(
    //             file => file.name.split('.').slice(0, -1).join('.')
    //             );
    //         setFieldValue('remark', fileNames.join(', '));
    //     } else {
    //         setFieldValue('remark', ''); // Clear if no files are selected
    //     }
    // };

    const handleFileChange = (e) => {
    const selectedFiles = e.target.files;
    setFieldValue('file', selectedFiles);

    // Only auto-fill remark if it's empty
    if (selectedFiles.length > 0 && !values.remark) {
        const fileNames = Array.from(selectedFiles).map(
            file => file.name.split('.').slice(0, -1).join('.')
        );
        setFieldValue('remark', fileNames.join(', '));
    }
};


    const getSelectedFileNames = () => {
        if (values.file && values.file.length > 0) {
            const fileNames = [];
            for (let i = 0; i < values.file.length; i++) {
                fileNames.push(values.file[i].name);
            }
            return fileNames.join(', ');
        }
        return 'Choose file';
    };
    // const handleFileChange = (e) => {
    //     const selectedFiles = e.target.files;
    
    //     if (selectedFiles.length === 1) {
    //         setFieldValue('file', selectedFiles[0]); 
    //         setFieldValue('remark', selectedFiles[0].name.split('.').slice(0, -1).join('.'));
    //     } else {
    //         setFieldValue('file', selectedFiles);
    //         setFieldValue('remark', ''); 
    //     }
    // };
    
    // const getSelectedFileNames = () => {
    //     if (values.file) {
    //         return values.file.name;
    //     }
    //     return 'Choose file';
    // };
    return (
        <Form autoComplete="disabled">
            <div className="form-row">
                <div className="form-group col-md-4">
                    <label>File Type</label>
                    <FormikSelect
                        name="fileType"
                        items={FILE_TYPES_LIST}
                        className="form-control"
                    />
                </div>
                <div className="form-group col-md-8">
                    <label>Select File To Upload</label>
                    <div className="custom-file">
                        <FormikFile
                            name="file"
                            className="custom-file-input"
                            multiple
                            onChange={handleFileChange}
                        />
                        <label
                            className="custom-file-label"
                            htmlFor="inputGroupFile01"
                        >
                            {/* {values.file ? values.file.name : 'Choose file'} */}
                            {/* {values.file && values.file.length > 0
                                ? values.file.map(file => file.name).join(', ')
                                : 'Choose file'} */}
                                  {getSelectedFileNames()}
                        </label>
                    </div>
                </div>
            </div>

            <div className="form-row">
                <div className="form-group col">
                    <label>About File</label>
                    <FormikInput
                        name="remark"
                        className="form-control"
                    />
                </div>
            </div>

            {/* UPLOAD BUTTON */}
            {canUpload ? (
                <div className="text-center">
                    <button
                        type="submit"
                        className="btn btn-primary"
                    >
                        Upload
                    </button>
                </div>
            ) : null}
        </Form>
    );
};

Render.propTypes = {
    values: PropTypes.shape({
        file: PropTypes.any,
    }).isRequired,
    canUpload: PropTypes.bool.isRequired,
};

const FileContainer = ({
    className,
    title,
    refId,
    source,
    canUpload,
}) => {
    // REDUX
    const dispatch = useDispatch();

    // const onSubmit = useCallback(
    //     async (
    //       { file: files, fileType, remark },
    //       { resetForm, setFieldValue }
    //     ) => {
    //      const eachRemarks = remark.split(",")
    //       for (let i = 0; i < files.length; i++) {
    //         await fileCreateAPI(
    //             {
    //                 files: files[i],
    //                 fileType,
    //                 remark:eachRemarks[i],
    //                 refId,
    //                 source,
    //               }
    //             )
    //         // await dispatch(
    //         //   fileInsertAction({
    //         //     files: files[i],
    //         //     fileType,
    //         //     remark,
    //         //     refId,
    //         //     source,
    //         //   })
    //         // );
    //       } 
    //       setFieldValue('remark', '');
    //       resetForm();         
    //       dispatch(fileSearchAction(
    //         {
    //         where: {
    //             refId,
    //             source,
    //         },
    //         fullTextSearch: false,
    //     } 
    //     ))
    //     dispatch(headerShowAction({
    //         data: files.length+' File Added',
    //     }))

    //     },
    //     [source, refId, dispatch]
    //   );

  const onSubmit = useCallback(
    async (
        { file: files, fileType, remark },
        { resetForm, setFieldValue }
    ) => {
        if (files && Array.from(files).some((file) => file.size > MAX_FILE_SIZE_BYTES)) {
            window.alert('File must be less then 7MB');
            return;
        }

        const eachRemarks = remark.split(',');
        let uploadedCount = 0;

        for (let i = 0; i < files.length; i++) {
            try {
                await fileCreateAPI({
                    files: files[i],
                    fileType,
                    remark: eachRemarks[i] || '',
                    refId,
                    source,
                });
                uploadedCount++;
            } catch (err) {
                dispatch(headerShowAction({
                    data: `Failed to upload file: ${files[i].name}`,
                    type: 'error',
                }));
            }
        }

        if (uploadedCount > 0) {
            dispatch(headerShowAction({
                data: `${uploadedCount} File(s) Uploaded`,
                type: 'success',
            }));
            setFieldValue('remark', '');
            resetForm();
            dispatch(fileSearchAction({
                where: { refId, source },
                fullTextSearch: false,
            }));
        }
    },
    [source, refId, dispatch]
);


    const onRemove = useCallback((
        { _id },
        // { resetForm },
    ) => {
        dispatch(fileRemoveAction({
            fileId: _id,
            refId,
            source,
        }));
    }, [
        refId,
        source,
        dispatch,
    ]);

    const where = useMemo(() => ({
        refId,
        source,
    }), [
        refId,
        source,
    ]);
    const dataPath = useMemo(() => `${source}-${refId}.search`, [
        refId,
        source,
    ]);

    if (!refId || !source) {
        return null;
    }

    return (
        <div className={className}>
            <div className="card mt-3">
                <div className="card-body">
                    <h5 className="card-title">
                        <i className="fas fa-file text-info" />
                        {' '}
                        {title}
                    </h5>

                    <Formik
                        onSubmit={onSubmit}
                        enableReinitialize
                        initialValues={FileDefaultProps}
                        validationSchema={FileYupSchema}
                    >
                        {(formikProps) => (
                            <Render
                                canUpload={canUpload}
                                {...formikProps}
                            />
                        )}
                    </Formik>

                    <SearchContainer
                        fullTextSearch={false}
                        className="mt-3"
                        reducer="FileReducer"
                        dataPath={dataPath}
                        action={fileSearchAction}
                        columns={columns}
                        queryParamsAsWhere={false}
                        where={where}
                        hasRemove
                        removeAction={onRemove}
                        rowDeletedCheckPath="deleted"
                        customActions={[
                            {
                                heading: 'Download',
                                Render: RenderDownload,
                            },
                        ]}
                    />
                </div>
            </div>
        </div>
    );
};

FileContainer.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    refId: PropTypes.string,
    source: PropTypes.string,
    canUpload: PropTypes.bool,
};

FileContainer.defaultProps = {
    title: 'Upload Files',
    className: '',
    refId: null,
    source: null,
    canUpload: true,
};

export default FileContainer;
